var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1Vendor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2054 2052",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.751499,0,0,1.00191,4.54747e-13,141.32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45483,0,0,1.05275,-651.53,-211.587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2085.24,1654.48C2213.93,1654.61 2258.29,1599.54 2258.41,1480.44C2258.68,1226.61 2255.99,829.395 2255.05,576.496C2254.58,449.77 2205.83,388.405 2028.18,389.067C1594.59,390.682 925.302,393.175 646.009,394.215C558.54,394.541 514.745,452.528 515.121,553.736C515.817,740.874 518.896,1327.74 518.697,1515.82C518.617,1591.71 572.277,1652.88 648.578,1652.96C926.008,1653.25 1751.21,1654.12 2085.24,1654.48Z",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "88.57px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.79372,0,0,1.3454,-1215.52,-524.153)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1098.84,
    cy: 846.269,
    r: 177.731,
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "74.19px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45831,0,0,1.30464,-653.332,-509.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1121.89,1165.29C1030.27,1165.82 911.54,1164.79 808.929,1164.54C645.386,1164.15 635.389,1425.8 635.389,1425.8C635.389,1425.8 1201.38,1426.36 1296.73,1425.8C1317.03,1425.69 1277.71,1164.39 1121.89,1165.29Z",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "82.91px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45831,0,0,1.09383,-688.013,-193.963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1584.54,739.042L2059.34,739.042",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "91.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45831,0,0,1.09383,-688.013,-75.2246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1584.54,739.042L2059.34,739.042",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "91.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45831,0,0,1.09383,-688.013,43.514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1584.54,739.042L2059.34,739.042",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "91.25px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Vendor);
export default __webpack_public_path__ + "static/media/step1Vendor.f16d2839ddd65c5465aab4cf2fad1c34.svg";
export { ForwardRef as ReactComponent };